"use client";
import { useUser } from "@auth0/nextjs-auth0/client";
import { Anchor, Button, Group } from "@mantine/core";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SideFlourish } from "@/components/general/decorative-lines/decorative-lines";
import { useUserContext } from "@/context/user-context-provider";

import { Logo } from "../logo/logo";
import styles from "./header.module.css";

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    const { user: session } = useUser();
    const { setUser } = useUserContext();
    const { t } = useTranslation();

    useEffect(() => {
        if (session) {
            fetchUserData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session]);

    const fetchUserData = async () => {
        try {
            const res = await fetch("/api/user", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: session.email }),
            });
            if (res.ok) {
                setUser(await res.json());
            }
        } catch (error) {
            console.error("Error fetching user:", error);
        }
    };

    useEffect(() => {
        if (session) {
            fetchUserData();
        }
    }, [session]);

    const navLinks = [
        { href: "/", label: t("navbar.home") },
        { href: "/roadmap", label: t("navbar.roadmap") },
        { href: "/about", label: t("navbar.about") },
    ];

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
            <Logo />

            {/* Navigation */}
            <Group gap="xxl" className={styles.nav}>
                <SideFlourish color="white" w={50} className={styles.sideFlourish} />
                {navLinks.map((link) => (
                    <Anchor key={link.href} component={Link} href={link.href} className={styles.navLink} unstyled>
                        {link.label}
                    </Anchor>
                ))}
                <SideFlourish color="white" w={50} flipped className={styles.sideFlourish} />
            </Group>

            {/* Actions */}
            <Group gap="xs" className={styles.loginButtonGroup}>
                {/* CTA Button */}
                {session ? (
                    <>
                        <Image
                            className={styles.header__profile__image}
                            src={session.picture}
                            alt="Dein Profilbild"
                            width={50}
                            height={50}
                            quality={80}
                        />
                        <Button component={Link} href="/api/auth/logout" prefetch={false} radius="xl" lts=".06rem">
                            {t("navbar.logout")}
                        </Button>
                    </>
                ) : (
                    <Button component={Link} href="/api/auth/login" prefetch={false} radius="xl" lts=".06rem">
                        {t("navbar.login")}
                    </Button>
                )}
            </Group>
        </header>
    );
};
